export function areCoordsEqual(coordArr1, coordArr2) {
  if (coordArr1.length !== coordArr2.length) return false;

  return coordArr1.every((point, index) => {
    const other = coordArr2[index];
    return point.x === other.x && point.y === other.y;
  });
}